import React, { useState } from 'react';
import Button from '@mui/material/Button';

import Bootstrap from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import AdelaideRivieraHotelStay from '../../pactum-server/stubs/stayContentFactory';

const StaysDetailModal: React.FC = () => {
  const [open, setOpen] = useState(false);

  const args = {
    stayId: undefined,
    open: open,
    stay: AdelaideRivieraHotelStay({}),
    room: undefined,
    onAction: () => setOpen(false),
  };

  return (
    <Bootstrap>
      <Button size="small" color="success" onClick={() => setOpen(true)}>
        Open Modal
      </Button>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'StaysDetailModal' }} {...args} />
    </Bootstrap>
  );
};

export default StaysDetailModal;
